import React, { Fragment, useState, useEffect, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import {
  BusinessCenter,
  MonetizationOn,
  Repeat,
  Report,
  AccountBalance,
} from "@material-ui/icons";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Alert from "@material-ui/lab/Alert";
import axios from "axios";
import Skeleton from "@material-ui/lab/Skeleton";
import Box from "@material-ui/core/Box";

import BarNeedsHas from "components/services/BarNeedsHas";
import BarEconomicSector from "components/services/BarEconomicSector";
import BarWasteType from "components/services/BarWasteType";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function DashboardBusinessNetworks() {
  const classes = useStyles();
  const [error, setError] = useState(false);
  const [loader, setLoader] = useState(true);

  const [values, setValues] = useState({
    organizationTypeName: "",
    organizationTypeCount: 0,
    economicSectorName: "",
    economicSectorCount: 0,
    wastesName: "",
    wastesCount: 0,
    totalRegisters: 0,
  });

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  useEffect(() => {
    axios
      .get(`${urlServices}preRegisters/totalAndMostRegistered`, {
        headers: {
          application: keyAplication,
        },
      })
      .then(
        (response) => {
          setValues({
            ...values,
            organizationTypeName: response.data.organizationType.name,
            organizationTypeCount: response.data.organizationType.count,
            economicSectorName: response.data.economicSector.name,
            economicSectorCount: response.data.economicSector.count,
            wastesName: response.data.wastes.name,
            wastesCount: response.data.wastes.count,
            totalRegisters: response.data.total,
          });
          setLoader(false);
        },
        (error) => {
          console.log(error);
          setError(true);
        }
      );
  }, [keyAplication, urlServices]);

  return (
    <Fragment>
      <GridContainer>
        {error ? (
          <GridItem xs={12} md={12}>
            <Alert severity="error">
              Error en la consulta con el servidor.
            </Alert>
          </GridItem>
        ) : (
          ""
        )}
        {loader ? (
          <Fragment>
            <GridItem xs={12} sm={6} md={3}>
              <Box sx={{ width: "100%", marginTop: "20%" }}>
                <Skeleton width="100%" height={200} />
              </Box>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Box sx={{ width: "100%", marginTop: "20%" }}>
                <Skeleton width="100%" height={200} />
              </Box>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Box sx={{ width: "100%", marginTop: "20%" }}>
                <Skeleton width="100%" height={200} />
              </Box>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Box sx={{ width: "100%", marginTop: "20%" }}>
                <Skeleton width="100%" height={200} />
              </Box>
            </GridItem>
          </Fragment>
        ) : (
          <Fragment>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader color="rose" icon stats>
                  <CardIcon color="rose">
                    <AccountBalance />
                  </CardIcon>
                  <h3 className={classes.cardTitleGraphs}>
                    <small>Total&nbsp;&nbsp;</small>
                    {values.organizationTypeCount}
                  </h3>
                  <br></br>
                  <div className={classes.cardTitleGraphs}>
                    {" "}
                    <center>
                      <h5>{values.organizationTypeName}</h5>
                    </center>
                  </div>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.cardSubTitle}>Actor más activo</div>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader color="success" icon stats>
                  <CardIcon color="success">
                    <MonetizationOn />
                  </CardIcon>
                  <h3 className={classes.cardTitleGraphs}>
                    <small>Total&nbsp;&nbsp;</small>
                    {values.economicSectorCount}
                  </h3>
                  <br></br>
                  <div className={classes.cardTitleGraphs}>
                    {" "}
                    <center>
                      <h5>{values.economicSectorName}</h5>
                    </center>
                  </div>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.cardSubTitle}>
                    Sector con mayor demanda
                  </div>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader color="danger" icon stats>
                  <CardIcon color="danger">
                    <Report />
                  </CardIcon>
                  <h3 className={classes.cardTitleGraphs}>
                    <small>Total&nbsp;&nbsp;</small>
                    {values.wastesCount * 30}
                  </h3>
                  <br></br>
                  <div className={classes.cardTitleGraphs}>
                    {" "}
                    <center>
                      <h5>{values.wastesName}</h5>
                    </center>
                  </div>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.cardSubTitle}>Mayor Residuo en KG</div>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader color="info" icon stats>
                  <CardIcon color="info">
                    <BusinessCenter />
                  </CardIcon>
                  <h3 className={classes.cardTitleGraphs}>
                    <small>Total&nbsp;&nbsp;</small>
                    {values.totalRegisters}
                  </h3>
                  <br></br>
                  <div className={classes.cardTitleGraphs}>
                    {" "}
                    <center>
                      <h5>Total de registros</h5>
                    </center>
                  </div>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.cardSubTitle}>
                    Registros
                  </div>
                </CardFooter>
              </Card>
            </GridItem>
          </Fragment>
        )}
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card chart>
            <CardBody>
              <h4 className={classes.cardTitleGraphs}>
                <Repeat className={classes.icontext} />
                Banco de recursos en Oferta y Demanda para mejorar la cadena de valor
              </h4>
              <BarNeedsHas />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} md={6}>
          <Card chart>
            <CardBody>
              <h4 className={classes.cardTitleGraphs}>
                <MonetizationOn className={classes.icontext} />
                Sectores económicos más registrados
              </h4>
              <BarEconomicSector />
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} md={6}>
          <Card chart>
            <CardBody>
              <h4 className={classes.cardTitleGraphs}>
                {" "}
                <Report className={classes.icontext} />
                Residuos más registrados
              </h4>
              <BarWasteType />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
}
